import { Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";


export default function OtherAbsentStaffList({ otherAbsentStaff }) {
  const { t } = useTranslation()

  return (
    <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                {t('Staff Name')}
              </TableCell>
              <TableCell>
                {t('Leave Type')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {otherAbsentStaff?.map((item, index) => (
              <TableRow key={`staff-${index}`}>
                <TableCell>
                  <Typography variant="body2">
                    {item?.lastName}, {item?.firstName} ({item?.jobTitle})
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={item?.leaveType}
                    size="small"
                    color="primary"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
